<template>
    <!-- 酒类预售订单 -->
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="demonstration">查询开始时间：</span>
                        <el-date-picker
                            v-model="start_time"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择开始时间"
                            @change="timeChangeStart"
                            style="width: 300px"
                        >
                        </el-date-picker>
                    </el-col>
                    <el-col :span="12">
                        <span class="demonstration">查询结束时间：</span>
                        <el-date-picker
                            v-model="end_time"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择结束时间"
                            @change="timeChangeEnd"
                            style="width: 300px"
                        >
                        </el-date-picker>
                    </el-col>
                </el-row>
            </div>
            <el-button type="primary" icon="el-icon-search" @click="searchGetLiquorSaleOrderList">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button v-if="loading" icon="el-icon-loading" disabled></el-button>
            <el-button icon="el-icon-setting" @click="toExport" v-else>导出</el-button>
        </div>
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="id" label="ID" min-width="120"> </el-table-column>
            <el-table-column prop="name" label="姓名" min-width="120"> </el-table-column>
            <!-- 手机号隐藏中间4位 手机号星号 -->
            <el-table-column label="手机电话">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="date" label="留资时间" min-width="120"> </el-table-column>
            <el-table-column prop="city_tag" label="地区" min-width="120"> </el-table-column>
        </el-table>
        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="Number(result_data)"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
var _this;
export default {
    data() {
        return {
            tableData: [],
            result_data: [],
            excelData: [],
            excelHead: [],
            loading: false,
            start_time: '',
            end_time: '',
            search_data: {
                page: 1,
                limit: 10,
                start_time: '',
                end_time: ''
            },
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.getLiquorSaleOrderList(); // 获取列表数据
    },
    methods: {
        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            console.log(val, 'val');
            _this.search_data.limit = val;

            //初始化列表
            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            console.log(val, 'val页码变化');
            _this.search_data.page = val;
            console.log(_this.search_data.page, '_this.search_data.page');
            //初始化列表
            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            console.log('翻页组件回调');
            //初始化列表
            _this.getLiquorSaleOrderList();
        },
        // 刷新按钮
        refresh() {
            this.$router.go(0);
        },

        // 导出
        toExport() {
            _this.loading = true;
            _this.search_data.page = 1;

            _this.getExcelData();
        },
        getExcelData() {
            _this
                .$post('/Liquorsaleorder/getLiquorSaleOrderList', _this.search_data)
                .then((res) => {
                    _this.progress_show = true;

                    _this.loading = false;

                    if (this.$route.path == '/liquorsaleorder') {
                        // 如果当前路由正确，导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.length; i++) {
                            _this.excelData.push({
                                id: res.data[i].id,
                                phone: res.data[i].phone,
                                name: res.data[i].name,
                                date: res.data[i].date,
                                city_tag: res.data[i].city_tag
                            });
                        }

                        console.log('_this.excelData');

                        if (_this.search_data.page * _this.search_data.limit < res.count) {
                            // 判断导出进度
                            _this.search_data.page += 1;
                            _this.progress_data = Math.floor(((_this.search_data.page * _this.search_data.limit) / res.count) * 100);
                            _this.getExcelData();
                        } else {
                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;
                        }
                    } else {
                        _this.progress_show = false;
                        _this.progress_data = 0;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = ['ID', '手机电话', '姓名', '留资时间', '地区'];
            const filterVal = ['id', 'phone', 'name', 'date', 'city_tag'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '酒类预售订单列表');
        },

        // 导出
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },

        // 查询开始时间
        timeChangeStart(val) {
            console.log(val);

            if (val != null ) {
                // 如果查询条件输入开始时间
                _this.search_data.start_time = _this.start_time;
            } else {
                // 如果查询条件未输入开始时间
                _this.search_data.start_time = '';
            }
        },

        // 查询结束时间
        timeChangeEnd(val) {
            console.log(val);

            if (val != null) {
                 // 如果查询条件输入结束时间
                _this.search_data.end_time = _this.end_time;
            } else {
                 // 如果查询条件未输入结束时间

                _this.search_data.end_time = '';
            }
        },

        // 搜索
        searchGetLiquorSaleOrderList() {
            _this.search_data.page = 1;
            _this.getLiquorSaleOrderList();
        },

        // 获取列表数据
        getLiquorSaleOrderList() {
            _this
                .$post('/Liquorsaleorder/getLiquorSaleOrderList', _this.search_data, _this.search_rules)
                .then((res) => {
                    _this.tableData = res.data;
                    _this.result_data = res.count;
                })
                .catch((err) => {});
        }
    }
};
</script>
<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>